import { ComponentProps } from 'react';
import { Tag } from '@consta/uikit/Tag';
import { IWarehouse, WarehouseTypes } from '@@/warehouses/ts';
import { WAREHOUSES_TYPES_ICON_DICTIONARY } from '@@/warehouses/dictionaries/types.dictionary';
import { UiIcon } from '@/modules/ui/components/ui-icon';

import styles from './index.module.sass';

export function WarehouseTypeTag(props: IWarehouseTypeTagProps) {
  const { type, ...rest } = props;
  const Icon = WAREHOUSES_TYPES_ICON_DICTIONARY[type as WarehouseTypes];
  const label = type === WarehouseTypes.Sleeve ? 'рукава' : 'склад';

  return (
    <Tag
      // @ts-ignore
      label={
        <div className={styles.label}>
          <UiIcon icon={<Icon />} className={styles.label__icon} />
          <span className={styles.label__text}>{label}</span>
        </div>
      }
      {...rest}
    />
  );
}

export type IWarehouseTypeTagProps = Omit<
  ComponentProps<typeof Tag>,
  'label' | 'icon'
> & {
  type: WarehouseTypes | IWarehouse['type'];
};
